import { render, staticRenderFns } from "./FlightGenerateCard.vue?vue&type=template&id=661b0a46"
import script from "./FlightGenerateCard.vue?vue&type=script&lang=js"
export * from "./FlightGenerateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports